import React from 'react';

import { StarFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';

import styles from './styles.module.css';

function FavouriteIcon() {
	return (
		<div className={styles.wrapper}>
			<Tooltip title="Favourite">
				<StarFilled className={styles.star} />
			</Tooltip>
		</div>
	);
}

export default React.memo(FavouriteIcon);
